<template>
    <div class="filtro-content">
        <i class="fas fa-filter filter-icon color-blue"></i>

        <el-select class="d-inline-block select-filter" size="small" filterable clearable v-model="grupo" placeholder="Selecione a loja de referência">
            <el-option
            v-for="item in optionsEmpresa"
            :key="item.id"
            :label="item.label"
            :value="item.id">
            </el-option>
        </el-select>

        <div class="pull-right" v-if="grupo">
            <el-button-group class="grupo-comparativo">
                <el-button :class="setComparativoClass('TerceiroQuartil')" @click="setComparativo('TerceiroQuartil')" size="mini">3° quartil</el-button>
                <el-button :class="setComparativoClass('Media')" @click="setComparativo('Media')" size="mini">Média</el-button>
                <el-button :class="setComparativoClass('Mediana')" @click="setComparativo('Mediana')" size="mini">Mediana</el-button>
            </el-button-group>

            <el-dropdown trigger="click">
                <el-button type="primary" :class="setComparativoClass('Maximo') || setComparativoClass('Minimo') || comparativo.length > 20 ? 'active' : ''"  size="mini">
                    <template v-if="setComparativoClass('Maximo')">
                        Máximo
                    </template>
                    <template v-if="setComparativoClass('Minimo')">
                        Mínimo
                    </template>
                    <template v-if="!setComparativoClass('Maximo') && !setComparativoClass('Minimo') && comparativo.length < 20">
                        Outros
                    </template>
                    <template v-if="comparativo.length > 20">
                        {{ NomeLoja.label }}
                    </template>
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="setComparativo('Maximo')">Máximo (última loja do quarto quartil)</el-dropdown-item>
                    <el-dropdown-item @click.native="setComparativo('Minimo')">Mínimo (primeira loja do primeiro quartil)</el-dropdown-item>
                    <el-select style="width:90%; margin: 4px 15px;" filterable clearable class="d-inline-block" size="small" v-model="comparativoLoja" placeholder="Selecione a Loja">
                        <el-option
                        v-for="item in lojasLista"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown trigger="click">
              <el-button :class="filtros.datas2 && filtros.datas2.length ? 'active' : ''" type="primary" icon="far fa-calendar-alt" size="mini" style="margin-left: 8px;margin-right: 3px;">
                <template v-if="filtros.datas2 && filtros.datas2.length">
                  {{ `${formatDateLabel(filtros.datas2[0])} - ${formatDateLabel(filtros.datas2[1])}`  }}
                </template>
              </el-button>
              <el-dropdown-menu slot="dropdown" style="padding: 7px">
                <el-date-picker
                  class="pull-right"
                  size="small"
                  ref="daterangepicker2"
                  v-model="filtros.datas2"
                  type="monthrange"
                  align="right"
                  unlink-panels
                  range-separator="-"
                  start-placeholder="Início"
                  end-placeholder="Fim"
                  format="MM/yyyy"
                  :picker-options="pickerOptions">
                </el-date-picker>
              </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>
 
 <script>
 import Moment from 'moment';
 export default {
    name: 'Filtro2',
    data() {
        return {
          grupo: '',
          optionsEmpresa: [],
          optionsCentroCusto: [],
          comparativo: 'TerceiroQuartil',
          paramsFiltros: {},
          lojasLista: [],
          comparativoLoja: '',
          NomeLoja: '',
          pickerOptions: {
            disabledDate: () => false, // Inicialmente, nenhuma data é desabilitada
          },
        }
    },
    computed: {
		  filtros: {
        get() {
            return this.$store.state.filtros;
        },
        set(value) {
          this.$store.commit('updateFiltros', value);
        }
      }
	  },
    methods: {
        async getListas(optModel, route) {
            
            this.grupo = '';
            this.formatValuesFilter(this.filtros);

            let response = await this.axios.get(route, {
                params: this.paramsFiltros
            });

            if(response.status !== 200) {
                return;
            }

            this.$data[optModel] = response.data;
        },
        formatValuesFilter(filtros) {
          this.paramsFiltros = {};

          const formatDateRange = (range) => {
            if (range && range.length) {
              this.paramsFiltros[`DataInicial`] = this.moment(range[0]).format('YYYY-MM-DD');
              this.paramsFiltros[`DataFinal`] = this.moment(range[1]).format('YYYY-MM-DD');
            }
          };

          // Formatar datas
          //formatDateRange(filtros.datas);
          formatDateRange(filtros.datas2);

          // Add tipo ao filtro
          if (filtros.tipo) {
            const key = filtros.selectedGroup ? 'Cluster._id' : 'Grupo._id';
            this.paramsFiltros[key] = filtros.tipo;
          }

          // Add comparativo ao filtro
          if (filtros.comparativo) {
            this.paramsFiltros.comparativo = filtros.comparativo;
          }
        },
        setComparativo(name) {
            this.comparativo = name;
            this.comparativoLoja = '';
        },
        setComparativoClass(name)  {
            return this.comparativo === name ? 'active' : '';
        },
        formatDateLabel(data) {
          return this.moment(data).format('DD/MM/YYYY')
        },
    },
    watch: {
        async 'filtros.tipo'() {
            await this.getListas('optionsEmpresa', this.$urls.EMPRESAS_DASH);
        },
        grupo(val){
            this.filtros = Object.assign(this.filtros, { grupo: val });
        },
        comparativoLoja(val) {
            this.NomeLoja = this.lojasLista.find(t => t.id == val);
            this.comparativo = val;
        },
        comparativo(val){
            this.filtros = Object.assign(this.filtros, { comparativo: val });
        },
        'filtros.datas2': {
          handler(newVal) {
              if (newVal && newVal.length) {
                this.filtros = Object.assign(this.filtros, newVal);
              }
          },
          deep: true,
        },
        "filtros.datas": {
          handler(newVal) {
            if (newVal && newVal.length) {
              const [start, end] = newVal; // Desestrutura as datas selecionadas

              this.pickerOptions = {
                ...this.pickerOptions,
                disabledDate: (time) => {
                  // Define o intervalo de datas permitidas
                  const minDate = Moment(start).startOf("month");
                  const maxDate = Moment(end).endOf("month");

                  return !Moment(time).isBetween(minDate, maxDate, "day", "[]");
                },
              };
            } else {
              // Restaura o comportamento padrão caso filtros.datas esteja vazio
              this.pickerOptions = {
                ...this.pickerOptions,
                disabledDate: () => false,
              };
            }
          },
          immediate: true, // Executa no carregamento inicial
        },
    },
    mounted() {
        this.getListas('optionsEmpresa', this.$urls.EMPRESAS_DASH);
        this.getListas('lojasLista', this.$urls.EMPRESAS_DASH);
    },
 }
 </script>
 
 <style lang="scss">
    .filtro-content {
        .filter-icon {
            position: absolute;
            left: 12px;
            top: 12px;
        }
        .select-filter {
            margin: 0 15px 0 35px;
            width:400px;
            @media screen and (max-width: 800px) {
				width:auto;
			}
        }
        .tag-filter {
            border-radius: 5px;
            border: 2px dashed #10B2EF;
            background: #d9f3fd;
            height: 31px;
            font-size: 0.8em;
            padding: 2px 6px;
            color: #0f7da7;
            display:inline-block;
            margin:0 5px;
        }
        .grupo-comparativo {
            margin-right: 8px;
        }
        .el-button.active {
            background: #16223d;
            color: #ffffff;
        }
    }
 </style>
